import React, { Component } from "react";
import { Link } from 'react-router-dom';
import GravityForm from "react-gravity-form";
import FadeIn from "react-lazyload-fadein";
import ScrollAnimation from 'react-animate-on-scroll';
import { Parallax } from 'react-scroll-parallax';

export default class ModText extends Component {
    render () {
	    let block = this.props.block;

	    return (
	        <div className={'l-block l-block--display-pullout scope-' + block.text_color} style={{backgroundColor: block.block_color}}>
	        	
	        	<div className={'c-pullout c-pullout--' + block.alignment}>
	        		
	        		
	        		
	        		{block.image_style !== 'inset' &&
		        		
		        		<div className="c-pullout__image">
		        		
			        		<Parallax className="c-pullout__image__inner" y={[-10, 10]} tagOuter="div">
			        			
			        			<FadeIn duration={250}>
									{onload => (
										<img
											src={block.src} 
											srcSet={block.srcset} 
											onLoad={onload}
										/>
									)}
								</FadeIn>
			        			
			        		</Parallax>
			        		
			        	</div>
		        		
		        	}
		        		
		        	{block.image_style === 'inset' &&
		        		
		        		<div className="c-pullout__image c-pullout__image--inset">
		        						        		
		        			<div style={{paddingTop:((block.img_height / block.img_width) * 100) + '%'}}>
		        			
			        			<FadeIn duration={250}>
									{onload => (
										<img
											src={block.src} 
											srcSet={block.srcset} 
											onLoad={onload}
										/>
									)}
								</FadeIn>
							
							</div>
			        						        		
			        	</div>
		        		
		        	}
		        			        		
	        		<div className={'c-pullout__text c-pullout__text--' + block.vertical_alignment}>
	        		
	        			<ScrollAnimation animateIn="fadeIn" animateOnce={true}>
	        			
		        			<div className="c-pullout__text__top">
	
		        				{block.subheading &&
			        				<h3 className="c-pullout__subheading">{ block.subheading }</h3>
		        				}
		        				
		        				{block.heading &&
			        				<h3 className="c-pullout__heading">{ block.heading }</h3>
		        				}
		        				
		        			</div>
		        			
		        			<div className="c-pullout__text__bottom">
		        				
		        				{block.text &&
			        				<div className={"scope-text scope-text--pullout"} dangerouslySetInnerHTML={ {__html: block.text } }></div>
		        				}
		        				{block.button_text && block.link_url && block.link_url.includes('https:') &&
									<a href={block.link_url} className={'c-pullout__link c-pullout__link--' + block.link_style} target="_blank">{ block.button_text }</a>
								}
								{block.button_text && block.link_url && block.link_url.includes('http:') &&
									<a href={block.link_url} className={'c-pullout__link c-pullout__link--' + block.link_style} target="_blank">{ block.button_text }</a>
								}
								{block.button_text && block.link_url && !block.link_url.includes('https') && !block.link_url.includes('http') &&
									<Link to={{ pathname: block.link_url }} className={'c-pullout__link c-pullout__link--' + block.link_style}>{ block.button_text }</Link>
								}
								{block.link_text && block.link_url && block.link_url.includes('https:') &&
									<a href={block.link_url} className={'c-pullout__link c-pullout__link--' + block.link_style} target="_blank">{ block.link_text }</a>
								}
								{block.link_text && block.link_url && block.link_url.includes('http:') &&
									<a href={block.link_url} className={'c-pullout__link c-pullout__link--' + block.link_style} target="_blank">{ block.link_text }</a>
								}
								{block.link_text && block.link_url && !block.link_url.includes('https') && !block.link_url.includes('http') &&
									<Link to={{ pathname: block.link_url }} className={'c-pullout__link c-pullout__link--' + block.link_style}>{ block.link_text }</Link>
								}
								
								{block.form_id &&
									<div className="scope-form scope-form--pullout">
					        			<GravityForm
											backendUrl={document.location.origin + '/wp-json/bloomingdales/v1/form'}
											formID={block.form_id}
										/>
									</div>
								}
		        			</div>
	        			
	        			</ScrollAnimation>
	        			
	        		</div>
	        		
	        	</div>
	        
			</div>
		)
	};

};
